window.oncontextmenu = (e) => {
  let element = $(e.target);
  let remoteParents = element.parents('[data-remote]');
  let hiddenSideParents = element.parents('[data-hidden-side-toggle]');
  if (element.data('remote') || element.data('hidden-side-toggle') || remoteParents.length > 0 || hiddenSideParents.length > 0) {
    return false;
  }
}

$(document).on('click', '*[data-remote],*[data-hidden-side-toggle]', (e) => {
  if (e.ctrlKey) {
    e.preventDefault()
  }
})
